import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  _id: '',
  remitUnit: '',
  fundNumber: '',
  name: '',
  address1: '',
  address2: '',
  address3: '',
  emailAddress: '',
  emailAddress2: '',
  emailAddress3: '',
  contactPerson: '',
  bankRoutingNum: '',
  bankAcctNum: '',
  envelopePrinting: '',
  unitName: '',
  warrantPrinting: '',
  achEft: '',
  bondExpires: '',

};

export const remitUnit = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadremitUnitRecords({ commit, dispatch }, {
      criteria, baseCrudKey,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query remitUnits($criteria: remitUnitCriteriaType) {
            remitUnits(criteria: $criteria) {
              ${fieldsToGqlString(fields)},
            }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { remitUnits } = results.data;
          commit('base/crud/setItems', [baseCrudKey, remitUnits], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting List.', { root: true });
      }
    },
    async upsertRemitUnit({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertremitUnit($item: remitUnitInputType!)  {
            upsertremitUnit(upsert: $item) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const remitData = rootGetters['base/crud/items'](baseCrudKey);
        const newRemitUnit = results.data.upsertremitUnit;
        const newList = mergeByIdNewAtTop(remitData || [], newRemitUnit);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the List', { root: true });
      }
    },
    async deleteRemitUnit({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteremitUnit ($id: ID!)  {
            deleteremitUnit(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteremitUnit._id;
        const remitData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = remitData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        // surface the backend refusal (e.g. code still in use); the dialog stays open
        const gqlErr = (e && e.graphQLErrors && e.graphQLErrors[0]) || {};
        const reason = (gqlErr.message || (e && e.message) || '')
          .replace(/^GraphQL error:\s*/, '');
        dispatch('flashError', reason || 'There was a problem deleting the remit unit', { root: true });
      }
    },
    async validateRemitUnit({ dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query validateRemitUnit {
              validateRemitUnit {
                isValid
                messages {
                  message
                  values
                }
              }
            }
          `,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results);
        if (results.data && results.data.validateRemitUnit) {
          return results.data.validateRemitUnit;
        }
        return { isValid: true, messages: [] };
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results);
        dispatch('flashError', 'There was a problem validating Remit Unit records.', { root: true });
        return { isValid: false, messages: [{ message: e.message || 'Unknown error' }] };
      }
    },
  },
};

export default remitUnit;
